// @ts-nocheck
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const ClosePartFinderModal: Handler = props => {
    props.dispatch({
        type: "Store/Components/PartFinder/ClosePartFinderModal",
    });
};

export const chain = [ClosePartFinderModal];

const closePartFinderModal = createHandlerChainRunnerOptionalParameter(chain, {}, "ClosePartFinderModal");
export default closePartFinderModal;
